import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { colors } from '../theme';

interface LegendItem {
  color: string;
  label: string;
  description: string;
}

function AwareLegend() {
  const legendItems: LegendItem[] = [
    {
      color: colors.aware.access,
      label: 'Access (Verde)',
      description: 'antibiotici con spettro di attività ristretto e un buon profilo di sicurezza in termini di reazioni avverse, da usare preferibilmente nella maggior parte delle infezioni più frequenti.',
    },
    {
      color: colors.aware.watch,
      label: 'Watch (Arancione)',
      description: 'antibiotici a spettro d\u2019azione più ampio, raccomandati come opzioni di prima scelta solo per particolari condizioni cliniche.',
    },
    {
      color: colors.aware.reserve,
      label: 'Reserve (Rosso)',
      description: 'antibiotici da riservare al trattamento delle infezioni da germi multiresistenti.',
    },
    {
      color: colors.aware.unclassified,
      label: 'Non classificato (Grigio)',
      description: '',
    },
  ];

  return (
    <Accordion elevation={2} sx={{ my: 0, mb: 1 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Legenda Codice Colore AWaRe</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
          {legendItems.map((item) => (
            <Box key={item.label} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  backgroundColor: item.color,
                  flexShrink: 0,
                  mt: '2px',
                }}
              />
              <Typography variant="body2">
                <Box component="span" sx={{ fontWeight: 600 }}>{item.label}</Box>
                {item.description && `: ${item.description}`}
              </Typography>
            </Box>
          ))}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          Il codice colore AWaRe è applicato esclusivamente agli antibiotici esplicitamente inclusi nel Manuale AWaRe AIFA/OMS.
          Gli antibiotici riportati come alternative cliniche nelle schede, ma non presenti nel Manuale AWaRe, non sono stati codificati secondo il codice colore.
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}

export default AwareLegend;
